import type { FunctionComponent, ReactElement } from 'react'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import style from './CustomTooltip.module.sass'

const tooltipStyle: React.CSSProperties = {
	backgroundColor: 'transparent',
	padding: 2,
	zIndex: 10,
}

type CustomTooltipProps = {
	textAfterHover?: ReactElement | string
	tooltipId: string
}

export const CustomTooltip: FunctionComponent<CustomTooltipProps> = ({ textAfterHover, tooltipId }) => {
	return (
		<>
			<ReactTooltip style={tooltipStyle} className={style.tooltipWrapper} id={tooltipId} offset={0}>
				<div className={style.tooltipText}>{textAfterHover}</div>
			</ReactTooltip>
		</>
	)
}
